import { api } from '@api'

const getTelephonePrefixes = async () => {
  try {
    const response = await api.get('/telephone-prefixes')
    return response.data
  } catch (error) {
    console.error('Error al obtener los prefijos telefónicos:', error)
    throw error
  }
}

export { getTelephonePrefixes }
